var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#1B9075"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.79 17.2432C25.825 17.2095 25.825 17.1757 25.825 17.1419C25.86 17.1081 25.895 17.0405 25.895 17.0068C25.895 16.973 25.93 16.9392 25.93 16.8716C25.93 16.8378 25.965 16.7703 25.965 16.7365C25.965 16.6689 26 16.6014 26 16.5338C26 16.5 26 16.5 26 16.4662C26 16.4324 26 16.4324 26 16.3986C26 16.3311 26 16.2635 25.965 16.1959C25.965 16.1284 25.93 16.0946 25.93 16.0608C25.93 16.027 25.895 15.9932 25.895 15.9595C25.86 15.8919 25.825 15.8581 25.79 15.7905C25.79 15.7568 25.755 15.7568 25.755 15.723C25.685 15.6554 25.65 15.5878 25.58 15.5203L19.245 9.40541C18.685 8.86486 17.81 8.86486 17.25 9.40541C16.69 9.94595 16.69 10.7905 17.25 11.3311L21.205 15.1486H6.4C5.63 15.1486 5 15.7568 5 16.5C5 17.2432 5.63 17.8514 6.4 17.8514H21.205L17.25 21.6689C16.69 22.2095 16.69 23.0541 17.25 23.5946C17.53 23.8649 17.88 24 18.23 24C18.58 24 18.93 23.8649 19.21 23.5946L25.58 17.4459C25.65 17.3784 25.72 17.3108 25.79 17.2432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBtn);
export default __webpack_public_path__ + "static/media/ArrowBtn.d78e96ee6a60053e4be0044f4029d174.svg";
export { ForwardRef as ReactComponent };